import React from 'react'
import PropTypes from 'prop-types'

/**
 * CheckMark svg icon.
 */
const CheckMark = ({ fill }) => (
  <svg width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.063 6.505L8.205.436a1 1 0 0 1 1.652 1.128L4.978 8.71a1 1 0 0 1-1.585.087L.24 5.114a1 1 0 1 1 1.52-1.3l2.303 2.69z" fill={fill ? fill : null} fillRule="evenodd" />
  </svg>
)

CheckMark.propTypes = {
  fill: PropTypes.string
}

export default CheckMark

